<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: 1000px;" v-columns-resizable).mb-5
        thead
          tr
            th(style="width: 80px;")
              div {{ $t('ui.time') }}
            th(style="width: 450px;")
              div {{ $t('ui.event') }}
            th
              div.text-center {{ $t('ui.full_time_ml') }}
            th
              div.text-center {{ $t('ui.half_time_ml') }}
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;")
              div.text-center(:class="{'up': item.fmlh_blink }") {{ item.fmlh }}
              div.text-center(:class="{'up': item.fmla_blink }") {{ item.fmla }}
            td(style="width: 100px;")
              div.text-center(:class="{'up': item.hmlh_blink }") {{ item.hmlh }}
              div.text-center(:class="{'up': item.hmla_blink }") {{ item.hmla }}
</template>

<script>

export default {
  components: {
  },
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
// .fixed-header-table {
//   thead tr th {
//     background: darkgray !important;
//   }
// }

// .fixed-header-table {
//   thead tr:nth-child(1) th{
//     position: sticky;
//     top: 0;
//     z-index: 10;
//   }
// }

// .fixed-header-table {
//   thead tr:nth-child(2) th{
//     position: sticky;
//     top: 29px !important;
//     z-index: 10;
//   }
// }
</style>
